import React, { useState, useContext } from 'react';

import { IdentifiedSpeciesContent, IdentifiedVirusContent, IdentifiedSpeciesDisplaySummary } from './IdentifiedSpeciesContent';
import IdentifiedSpeciesMenu from './IdentifiedSpeciesMenu';
import { Box, Grid, Paper, Button } from '@mui/material';
import TuneIcon from '@mui/icons-material/Tune';
import ResistanceGenesDialog from './ResistanceGenesDialog';
import { IdentifiedSpeciesFiltersDispatchContext, IdentifiedSpeciesFiltersContext } from '../context/IdentifiedSpeciesFiltersContext';

export const IdentifiedOrganismsBox = ({
    isDiagnosticView,
    identifiedSpecies,
    isIllumina,
    run,
    sample,
    analysis,
    totalMicrobialMegabases,
    organization,
  }) => {
    const [isResistanceGeneDialogOpen, setIsResistanceGeneDialogOpen] = useState(false);

    const { visibleSpeciesCt } = useContext(IdentifiedSpeciesFiltersContext);
    const { setFilterDialogOpen } = useContext(IdentifiedSpeciesFiltersDispatchContext);
    
    const hasAccessExtendedResistanceGenePanel = organization?.attributes?.metadata?.FF_expanded_resistance_gene_panel === true;
  
  return (
    <Grid item xs={12}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Paper elevation={2}>
          <Box sx={{ backgroundColor: '#eee', padding: '1px 10px' }}>
              <Grid container>
                <Grid item xs={2.5}>
                  <p>
                    <b>
                      {isDiagnosticView ? 'DETECTED' : 'IDENTIFIED'} ORGANISMS
                    </b>
                  </p>
                </Grid>
                <Grid item xs={6}>
                  <p><IdentifiedSpeciesDisplaySummary
                    identifiedSpecies={identifiedSpecies}
                    displayingSpeciesCt={visibleSpeciesCt}
                  /></p>
                </Grid>
                <Grid item xs={3.5} sx={{
                  textAlign: 'right', 
                  paddingTop: "10px",
                  paddingBottom: "10px",
                  display: 'flex',
                  justifyContent: 'flex-end',
                }}>
                  {!isDiagnosticView && (
                    <Button 
                      size="small" 
                      color="primary" 
                      variant="contained"
                      aria-label="open-tune-dialog"
                      onClick={() => setFilterDialogOpen(true)}
                      startIcon={<TuneIcon />}
                    >
                      CHANGE RESULTS DISPLAY
                    </Button>
                  )}
                  <IdentifiedSpeciesMenu
                    loading={!identifiedSpecies}
                    isIllumina={isIllumina}
                    run={run}
                    sample={sample}
                    analysis={analysis}
                    identifiedSpeciesList={identifiedSpecies}
                    totalMicrobialMegabases={totalMicrobialMegabases}
                    setIsResistanceGeneDialogOpen={setIsResistanceGeneDialogOpen}
                    hasAccessExtendedResistanceGenePanel={hasAccessExtendedResistanceGenePanel}
                  />
                  <ResistanceGenesDialog
                      isIllumina={isIllumina}
                      analysis={analysis}
                      sample={sample}
                      open={isResistanceGeneDialogOpen}
                      onClose={() => setIsResistanceGeneDialogOpen(false)}
                      identifiedSpecies={identifiedSpecies}
                  />
                </Grid>
              </Grid>
            </Box>
            <Box>
              <IdentifiedSpeciesContent
                isIllumina={isIllumina}
                isDiagnosticView={isDiagnosticView}
                loading={!identifiedSpecies}
                identifiedSpecies={identifiedSpecies}
                visibleSpeciesCt={visibleSpeciesCt}
                totalMicrobialMegabases={totalMicrobialMegabases}
              />
              <IdentifiedVirusContent
                isIllumina={isIllumina}
                isDiagnosticView={isDiagnosticView}
                loading={!identifiedSpecies}
                identifiedSpecies={identifiedSpecies}
                visibleSpeciesCt={visibleSpeciesCt}
                totalMicrobialMegabases={totalMicrobialMegabases}
              />
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default IdentifiedOrganismsBox;
